import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_TimeOffRequestForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_TimeOffRequestForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Time off Request Form</h3><br />
                    Use a separate form for each time off request.
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Title/Position:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName' name='txtName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtTitlePosition' name='txtTitlePosition' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Identified Coverage:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Number of Day Requested:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtIdentifiedCoverage' name='txtIdentifiedCoverage' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtNumberOfDayRequested' name='txtNumberOfDayRequested' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Starting On:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Ending On:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Returning On:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtStartingOn' name='txtStartingOn' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtEndingOn' name='txtEndingOn' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtReturningOn' name='txtReturningOn' className='add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>Vacation request must be submitted 30days in advance unforeseen event up to 1hour before shift <br />
                    “Refer to ADP <a href="(www.myadp.com)">(www.myadp.com) </a>for available PTO/Vacation Hours</p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>TYPE OF REQUEST</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfRequest_1' name='rbTypeOfRequest' className='add-only' value='Vacation' /> Vacation</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfRequest_2' name='rbTypeOfRequest' className='add-only' value='PersonalLeave' /> Personal Leave (Unpaid)</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfRequest_3' name='rbTypeOfRequest' className='add-only' value='BereavementLeave' /> Bereavement Leave</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfRequest_4' name='rbTypeOfRequest' className='add-only' value='JuryDuty' /> Jury Duty</td>
                    </tr>
                    <tr>

                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfRequest_5' name='rbTypeOfRequest' className='add-only' value='FamilyMedicalLeave' /> Family & Medical Leave </td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfRequest_6' name='rbTypeOfRequest' className='add-only' value='SickTime' /> Sick Time</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfRequest_7' name='rbTypeOfRequest' className='add-only' value='Birthday' /> Birthday</td>
                        <td className='w-187'>
                            <input type='radio' id='rbTypeOfRequest_8' name='rbTypeOfRequest' className='add-only' value='MilitaryLeave' /> Military Leave</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfRequest_9' name='rbTypeOfRequest' className='add-only' value='PersonalTimeOff' /> Personal Time Off <b>(Hours available:)</b>
                            <input type='text' id='txtHoursAvailable' name='txtHoursAvailable' className='add-only w-100 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbTypeOfRequest_10' name='rbTypeOfRequest' className='add-only' value='Others' /> Others:</td>
                        <td className='w-650'>
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type='checkbox' id='cbUnderStandThatTime' name='cbUnderStandThatTime' className='add-only' value='UnderstandThatTimeOffFromWork' /> I understand that time off from work is subject to management approval and company policies
                    <br />
                    <input type='checkbox' id='cbUnderStandThatTime' name='cbIAttestThatAllDuties' className='add-only' value='IAttestThatAllDuties' /> I attest that all duties/assignments will be completed prior to leave
                    <br />
                    <input type='checkbox' id='cbUnderStandThatTime' name='cbUponApprovalIWillSchedule' className='add-only' value='UponApprovalIWillSchedule' /> Upon approval I will schedule a meeting with supervisor to discuss all tasks/responsibilities at least 2 days prior to leave</p>

                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Employee's Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Administrator Approval:</span>
                    <input type='radio' id='rbAdministratorApproval_13' name='rbAdministratorApproval' className='add-only' value='Approved' /> Approved &nbsp;
                    <input type='radio' id='rbAdministratorApproval_14' name='rbAdministratorApproval' className='add-only' value='NotApproved' /> Not Approved
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Scheduled meeting date and time:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='time' id='txtTime' name='txtTime' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>COMMENT:</span>
                    <textarea id='txtComment' name='txtComment' className='add-only'></textarea>
                    <br />
                    <span className='eleHeader'>Supervisor's printed name</span>
                    <input type='text' id='txtSupervisorPrinted' name='txtSupervisorPrinted' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='signature w-600'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-600'>Supervisor's Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>**Must be signed with printed name, Signature/credentials**
                            </b></td>
                    </tr>
                </table>







            </div>
        </form>

    )
}   